export const SAFETY_VALVE_REPORTS_API = "SAFETY_VALVE_REPORTS";
export const MANUAL_VALVE_REPORTS_API = "MANUAL_VALVE_REPORTS";
export const REPORT_UPDATED_TIME_CHECK = "REPORT_UPDATED_TIME_CHECK";
export const REPORT_SITES = "REPORT_SITES";
export const VALVE_TEST_HISTORY_EXPORT = "VALVE_TEST_HISTORY_EXPORT";
